import Swiper, { Autoplay, Navigation } from 'swiper';
import $ from 'jquery';
import { breakpoints } from 'js/config/breakpoints';

const slider = '.js-hero-swiper';
const sliderMainWrap = '.hero';
const nextSlideNavEl = '.swiper-button-next';
const prevSlideNavEl = '.swiper-button-prev';
const slideNavBlock = '.swiper__navigate-block';

document.addEventListener('DOMContentLoaded', () => {
  const heroArrowBtnClass = '.hero__mobile-arrow';
  const heroMain = '.hero';
  const heroArrowEl = document?.querySelector(heroArrowBtnClass);

  if (heroArrowEl !== null) {
    heroArrowEl.addEventListener('click', () => {
      const parent = heroArrowEl.closest(heroMain);
      const nextEl = parent.nextElementSibling;

      const offset = (window.innerWidth > breakpoints.sm) ? 98 : 50;
      const yCoordinate = nextEl.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: yCoordinate,
        behavior: 'smooth',
      });
    });
  }
});

function toggleNavigationView($slider) {
  const swiperDisabledClass = 'swiper-button-disabled';
  const mainWrap = $slider.closest(sliderMainWrap);
  const navBlock = mainWrap.find(slideNavBlock);
  const prevButton = navBlock.find(prevSlideNavEl);
  const nextButton = navBlock.find(nextSlideNavEl);
  if (prevButton.hasClass(swiperDisabledClass) && nextButton.hasClass(swiperDisabledClass)) {
    navBlock.hide();
  } else {
    navBlock.show();
  }
}

function initSlider($slider) {
  const swiper = new Swiper($slider[0], {
    modules: [Autoplay, Navigation],
    loop: false,
    init: false,
    freeMode: true,
    spaceBetween: 0,
    centeredSlides: false,
    slidesPerView: 1,
    keyboard: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    navigation: {
      nextEl: $slider.closest(sliderMainWrap).find(nextSlideNavEl)[0],
      prevEl: $slider.closest(sliderMainWrap).find(prevSlideNavEl)[0],
    },
    on: {
      transitionEnd: () => {
        $(document).trigger('slider-transition-end', {
          slider: this,
        });
      },
    },
  });

  swiper.init();
  toggleNavigationView($slider);
}

$(document).ready(() => {
  if ($(slider).length) {
    $(slider).each(function () {
      initSlider($(this));
    });
  }
});
